import { AbstractLayer } from './abstract-layer';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TintableLayerData } from 'src/app/data/configurator/layer/tintable-layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';

declare const fabric: any;

export class LineLayer extends AbstractLayer {


  /**
   * Contructor
   */
  constructor(data: LayerData, stage: any) {
    super(data, stage);
  }

  /**
   * Draw
   */
  public draw(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._display = new fabric.Rect({
        y: -50,
        width: 100,
        height: 100,
        fill: '#000'
      });

      this._display.setControlsVisibility({
        bl: false,
        br: false,
        mb: false,
        ml: true,
        mr: true,
        mt: false,
        tl: false,
        tr: false,
        mtr: true,
      });

      this._display.clone((cloned) => {
        this._preview = cloned;
        super._draw();

        resolve(true);
      });
    });
  }

  /**
   * Update data
   */
  updateData(object: any): void {
    let positionData = { x: this.data.x, y: this.data.y, width: this.data.width, height: this.data.height, rotation: this.data.rotation };
    HistoryData.add(this._labelData, this.data, CommandData.SET_POSITION, positionData);

    super.updateData(object);
  }

  /**
   * Update view
   */
  updateView(): void {
    this._display.set({
      fill: (<TintableLayerData>this._data).color
    });

    this._preview.set({
      fill: (<TintableLayerData>this._data).color
    });

    super.updateView();

    this._display.setCoords();
  }

  /**
   * Cleanup
   */
  public cleanup(): void {

  }
}
